import type { AppRouteRecordRaw } from '@/router/types'

export const systemLogRoutes: AppRouteRecordRaw[] = [
  {
    path: 'systemLog',
    name: 'SystemLog',
    component: () => import('@/views/systemManage/systemLog/index.vue'),
    meta: {
      title: '系统日志'
    },
    children: [
      {
        path: 'loginLog',
        name: 'LoginLog',
        component: () => import('@/views/systemManage/systemLog/loginLog/index.vue'),
        meta: {
          title: '登录日志'
        }
      },
      {
        path: 'operateLog',
        name: 'OperateLog',
        component: () => import('@/views/systemManage/systemLog/operateLog/index.vue'),
        meta: {
          title: '操作日志'
        }
      },
      {
        path: 'hitdbRecord',
        name: 'hitdbRecordManage',
        component: () => import('@/views/systemManage/systemLog/hitdbRecord/index.vue'),
        meta: {
          title: '撞库记录'
        }
      }
    ]
  }
]
